import { render } from "./textBox.vue?vue&type=template&id=295c975c&scoped=true"
import script from "./textBox.vue?vue&type=script&lang=js"
export * from "./textBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295c975c"]])

export default __exports__